"use client";

import React from "react";
import Link from "next/link";

const AllOn6Intro: React.FC = () => {
  return (
    <section className="w-full py-6 sm:py-8 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          Losing teeth changes more than your smile; it reshapes the way you
          eat, speak, and even how your face looks over time. For patients
          facing significant tooth loss, that gradual decline can feel
          inevitable. It doesn&apos;t have to be. At{" "}
          <Link
            href="/"
            className="inline-block bg-gradient-to-r from-[#AE7D2F] via-[#ECD05B] to-[#AE7D2F] bg-clip-text text-transparent hover:underline transition-all duration-300 ease-in-out"
          >
            Smile4Me Dental Care
          </Link>
          , Dr. Khaimov offers All-on-6 dental implants in Astoria as a
          permanent, fixed solution built to last; backed by advanced
          technology, flexible financing, and care that&apos;s tailored to you
          from the first consultation to the final restoration.
        </p>
      </div>
    </section>
  );
};

export default AllOn6Intro;
